/**
 * Phase 20 Plan 20-02 — Relative time formatter.
 *
 * Converts an ISO-8601 date string (or Date) into a human-friendly relative
 * string suitable for the NotificationsBell dropdown and AlertsListPage.
 *
 * Format rules:
 *   < 60 seconds   → "just now"
 *   < 60 minutes   → "{N}m ago"
 *   < 24 hours     → "{N}h ago"
 *   < 30 days      → "{N}d ago"
 *   >= 30 days     → locale short date ("Apr 12")
 */

const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
] as const;

export function formatRelative(date: string | Date): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const diffMs = Date.now() - d.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHr = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHr / 24);

  if (diffSec < 60) return 'just now';
  if (diffMin < 60) return `${String(diffMin)}m ago`;
  if (diffHr < 24) return `${String(diffHr)}h ago`;
  if (diffDay < 30) return `${String(diffDay)}d ago`;

  const month = MONTHS[d.getMonth()];
  if (month === undefined) return d.toLocaleDateString();
  return `${month} ${String(d.getDate())}`;
}
